<template>
  <el-dialog
    class="select-menu-items-modal"
    :title="restaurant.ProviderName"
    :visible.sync="visible"
    width="1200px"
  >
    <div class="content" v-loading="loading">
      <div class="header"></div>
      <div class="table">
        <div class="table-wrapper">
          <el-table :data="list" stripe style="width: 100%" height="100%">
            <el-table-column prop="index" label="#" align="center" width="60"></el-table-column>
            <el-table-column prop="childrenCategory" label="菜品类型" align="center" width="120"></el-table-column>
            <el-table-column label="图片"></el-table-column>
            <el-table-column prop="serviceName" label="菜名"></el-table-column>
            <el-table-column prop="chargeMode" label="计价单位" width="120"></el-table-column>
            <el-table-column label="单价" prop="price" align="center" width="200"></el-table-column>
            <el-table-column prop="operation" label="操作" fixed="right" width="180">
              <template slot-scope="scope">
                    <div v-for="(item,index) in scope.row.sku" :key="index">
                      <span v-if="selectedIdCountMap[item.gid]">{{item.name}}</span>
                      <el-input-number
                        v-if="selectedIdCountMap[item.gid]"
                        v-model="selectedIdCountMap[item.gid]"
                        :min="0"
                        :max="99"
                        size="small"
                        @change="onCountChange(scope.row, arguments[0],index)"
                      ></el-input-number>
                    </div>
                <el-button
                  size="small"
                  type="text"
                  @click="select(scope.row)"
                  v-if="!scope.row.sku || scope.row.sku.length==0 || (scope.row.skuLength!=1 && scope.row.sku.length < scope.row.skuLength)"
                >选择</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <el-pagination
        @size-change="loadData(1, arguments[0])"
        @current-change="loadData(arguments[0])"
        :current-page="pagination.index + 1"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="pagination.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      ></el-pagination>
      <div class="footer">
        <div class="menu-list">
          已选：
          <span v-for="item in selectedItems" :key="item.gid">
            <span v-for="skuItem in item.sku" :key="skuItem.gid">
              {{item.serviceName}}-{{skuItem.name}}
              <i>*{{skuItem.count | 1}}</i>
            </span>
          </span>
        </div>
        <div class="price">
          <p>已选：{{totalCount}}份餐品</p>
          <p>
            价格：
            <b>{{totalPrice}}</b>元 另需配送费
            <b>2</b>元
          </p>
        </div>
        <div class="button" @click="close()">选好了</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash'
import ModalMixin from '@/libs/modal/modal-mixin'
import MenuOverviewPopper from '@/components/pages/orders/dinner/MenuOverviewPopper'

export default {
  components: { MenuOverviewPopper },
  mixins: [ModalMixin],
  data() {
    return {
      pagination: {
        index: 0,
        total: 0,
        size: 20
      },
      list: [],
      loading: false,
      restaurant: {},
      tempTotal: 0,
      selectedItems: [],
      selectedIdCountMap: {}
    }
  },
  computed: {
    totalPrice() {
      let total = 0
      // for (let item of this.selectedItems) {
      //   total += (item.count || 0) * (+item.sku.price || +item.sku.Price || 0)
      // }
      for (let item of this.selectedItems) {
        for(let sku of item.sku){
          if(this.selectedIdCountMap[sku.gid]){
            total += ( this.selectedIdCountMap[sku.gid] || 0 ) * ( sku.price || 0 );
          }
        }
      }
      return total
    },
    totalCount() {
      let total = 0
      // for (let item of this.selectedItems) {
      //   total += item.count || 0
      // }
      for (let item of this.selectedItems) {
        for(let sku of item.sku){
          if(this.selectedIdCountMap[sku.gid]){
            total += ( this.selectedIdCountMap[sku.gid] || 0 ) ;
          }
        }
      }
      return total
    }
  },
  methods: {
    init(restaurant, selectedItems) {
      this.restaurant = restaurant
      this.selectedItems = selectedItems
      let map = {}
      for (let item of this.selectedItems) {
        for(let sku of item.sku){
          map[sku.gid] = sku.count || 1
        }
      }
      this.selectedIdCountMap = map
      this.loadData()
      return this.open()
    },
    loadData(index, size) {
      index = index - 1 || 0
      size = size || this.pagination.size
      this.loading = true
      this.Service.call('serviceitem', 'GET', { index, size, serviceprovidergid: this.restaurant.gid }).then(data => {
        _.forEach(data.data, (item, idx) => {
          item.index = idx + 1
        })
       
        let list = data.data || [];
        data.data.forEach((element,index) => {
          for(let select of this.selectedItems){
            if(element.gid === select.gid){
              list.splice(index,1,select);
            }
          }
        });
        this.list = list;
          
        this.pagination = {
          index: data.index,
          size: data.size,
          total: data.total
        }
      }).finally(() => {
        this.loading = false
      })
    },
    select(row) {
      // 查询sku，然后判断是有多个，多个就得选择了
      this.modal('SelectSkuModal', row.gid).promise.then(sku => {
        if (sku && sku.sku.gid) {
          let sameData = row.sku?true:false;
          let arrSku = sameData?row.sku:[];
          sku.sku.count = 1;
          arrSku.push(sku.sku);
          this.$set(row, 'sku', arrSku)
          this.$set(this.selectedIdCountMap, sku.sku.gid, 1)
          this.$set(row, 'skuLength', sku.length)
          if(sameData){
            let list = this.selectedItems;
            list.forEach(element => {
              if(element.gid == row.gid){
                element = row;
              }
            });
            this.$set(this, 'selectedItems', list);
          }else{
            this.selectedItems.push(row)
          }
          
        }
      })
    },
    onCountChange(row, count,skuIndex) {
      if (count > 0) {
        let item = _.find(this.selectedItems, e => e.gid === row.gid)
        let sku = item.sku;
        sku[skuIndex].count = count;
        this.$set(this.selectedIdCountMap, item.sku[skuIndex].gid, count)
        this.$set(item, 'sku', sku)
      } else {
        let element = _.find(this.selectedItems, e => e.gid === row.gid)
        let sku = element.sku;
        this.$set(this.selectedIdCountMap, element.sku[skuIndex].gid, 0)
        sku.splice(skuIndex,1);
        this.$set(element, 'sku', sku);
        if("undefined" ===typeof sku){
          this.$set(element, 'sku', sku);
        }else{
          _.pull(this.selectedItems,element);
        }
      }
    },
    close() {
      this.visible = false
      this.reject = null
      this.resolve && this.resolve(this.selectedItems)
    }
  }
}
</script>
